<template>
  <header>
    <el-row :gutter="20">
      <el-col :xs="24" :sm="16">
        <div class="banner" v-if="$event.Banner">
          <img :src="$event.Banner" />
        </div>
      </el-col>
      <el-col :xs="24" :sm="8">
        <div class="title">{{ $event.EventName }}</div>
        <div class="s-title">{{ $event.Organizer }}</div>
        <div class="content">
          <div class="price">
            <template v-if="$event.Ticket">
              <span v-if="$event.Ticket.Min == 0 && $event.Ticket.Max == 0">免费</span>
              <span v-else-if="$event.Ticket.Min == 0 && $event.Ticket.Max > 0">0 - {{ $event.Ticket.Max }}（{{ $event.Ticket.Currency }}）</span>
              <span v-else-if="$event.Ticket.Min > 0 && $event.Ticket.Min == $event.Ticket.Max">{{ $event.Ticket.Max }}（{{ $event.Ticket.Currency }}）</span>

              <span v-else>{{ $event.Ticket.Min }} - {{ $event.Ticket.Max }}（{{ $event.Ticket.Currency }}）</span>
            </template>
          </div>
          <div class="share"></div>
        </div>
        <el-row :gutter="24">
          <el-col :span="12"><el-button size="large" type="primary" @click="emit('login')">{{ $t('index.register') }}</el-button></el-col>
          <el-col :span="12"><el-button size="large" type="primary" @click="emit('login')">{{ $t('index.confirmation') }}</el-button></el-col>
        </el-row>
        <div class="btn"></div>
      </el-col>
    </el-row>
  </header>
</template>

<script setup>
  import { ref, inject } from 'vue'

  import VSideBar from './sidebar.vue'
  //
  const $event = inject('$event')
  const emit = defineEmits(['login'])

  
  const $language=inject('$language')
</script>

<style lang="scss" scoped>
  header {
    .el-col {
      margin-bottom: 20px;
    }
    .banner {
      img {
        width: 100%;
        display: block;
      }
    }
    .title {
      font-size: 18px;
    }
    .s-title {
      color: #777;
      font-size: 14px;
    }
    .content {
      padding: 35px 0 20px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .el-button {
      width: 100%;
    }
  }
</style>
